import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Avatar,
  Button,
  Grid,
  TextField,
  Typography,
  Paper,
  Box,
  Select,
  MenuItem,   
  FormControl,
  InputLabel
} from "@mui/material";

import axios from "../api/baseurl";
import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { fetchSecretKey } from "../encryptionAndDecryption/secretKeyDecryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { toast } from "react-toastify";
import { Country, State, City } from "country-state-city";
import { formatDateDDMMYYYY , toYYYYMMDD} from "utils/dateFormatter";
import MedicalAbstractBackground from "track/MedicalAbstractBackground ";

function ProfileIcon() {
  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const userid = loginData?.userid;
   const role = loginData?.role;

  const [profileData, setProfileData] = useState({
    // userid:userid,
    id:"",
    image:"",
    imageMeta:"",
    firstname: "",
    lastname:"",
    dob: "",
    username: "",
    phoneNumber: "",
   age:"",
   martialStatus:"",
    tan:"",
    gender:"",
    address:"",
      city:"",
    state:"",
    country:"",
     pin:"",
    
 });
 

 const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
 const [districts, setDistricts] = useState([]);
    const navigate = useNavigate();

  const handleChange = (e) => {
    setProfileData({ ...profileData, [e.target.name]: e.target.value });
  };

  
 useEffect(() => {
  if (role === "ROLE_SUPER") {
    toast.info(
      "Profile updates are restricted for Super Administrator accounts. Please contact the system administrator if changes are required.",
      {
        autoClose: 6000,
      }
    );
  }
}, [role]);

 

  const fetchProfile = async () => {
    try {
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;

      const response = await axios.get(`/api/user/profile/details/${userid}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const decrypted = decryptBody(response.data, secretKey);
      console.log("Decrypted Profile Data:", decrypted); 
      setProfileData({
        // userid:decrypted.userid,
        image: decrypted.image,
  imageMeta: decrypted.imageMeta,
        id: decrypted.id,
        firstname: decrypted.firstname,
        dob: toYYYYMMDD(decrypted.dob),
        username: decrypted.email,
        phoneNumber: decrypted.phoneNumber,
        lastname: decrypted.lastname,
        age: decrypted.age,
        gender:decrypted.gender,
       martialStatus:decrypted.martialStatus,
       address:decrypted.address,
       country:decrypted.country,
       state:decrypted.state,
       city:decrypted.city,
       pin:decrypted.pin,

       
        // pin:decrypted.pin,
        // state:decrypted.state,
        // country: decrypted.country,
        // latitude:decrypted.latitude,
        // longitude:decrypted.longitude,
     
     
      });
    } catch (error) {
      console.error("Profile fetch failed:", error);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = reader.result.split(",")[1];
        const meta = {
          name: file.name,
          size: file.size,
          type: file.type,
        };
        setProfileData((prevData) => ({
          ...prevData,
          image: base64,
          imageMeta: JSON.stringify(meta),
        }));
      };
      reader.readAsDataURL(file);
    }
  };



  useEffect(() => {
   setCountries(Country.getAllCountries());
 }, []);

  useEffect(() => {
   if (profileData.country) {
     const statesData = State.getStatesOfCountry(profileData.country);
     setStates(statesData);
 
     if (profileData.state) {
       const citiesData = City.getCitiesOfState(profileData.country, profileData.state);
       setDistricts(citiesData);
     }
   }
 }, [profileData.country, profileData.state]);
 
 
 // when country changes → update states
 const handleCountryChange = (countryCode) => {
   setProfileData((prev) => ({
     ...prev,
     country: countryCode,
     state: "",
     city: "",
   }));
   setStates(State.getStatesOfCountry(countryCode));
   setDistricts([]);
 };
 
 const handleStateChange = (stateCode) => {
   setProfileData((prev) => ({
     ...prev,
     state: stateCode,
     city: "",
   }));
   setDistricts(City.getCitiesOfState(profileData.country, stateCode));
 };
 
 const handleCityChange = (cityName) => {
   setProfileData((prev) => ({
     ...prev,
     city: cityName,
   }));
 };


 
  // In your handleSave function, modify the profileData to include userid
const handleSave = async () => {
  try {
    const secretKey = await fetchSecretKey();
    const token = JSON.parse(localStorage.getItem("loginData"))?.token;
    
    // Add userid to the profile data before sending
    const dataToSend = {
      ...profileData,
      id: userid, // Add this line
      dob:formatDateDDMMYYYY(profileData.dob),
    };
    
    console.log("Profile data before encryption:", dataToSend);
    const encryptedBody = encryptBody(dataToSend, secretKey);

    console.log("Sending Encrypted Body:", encryptedBody);


    const response = await axios.post("/api/user/profile/details/update",encryptedBody,
     {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    });
    
    if (response.status === 200) {
      const decryptedResponse = decryptBody(response.data, secretKey);
      console.log("Decrypted Response:", decryptedResponse);

      if (!decryptedResponse || !decryptedResponse.id) {
        throw new Error("Decryption failed or invalid response.");
      }
      toast.success(decryptedResponse.message || "Profile updated successfully!");
await fetchProfile();  
     navigate("/dashboard");

 }
  } catch (error) {
    toast.error(error.message || "Failed to update Profile.");
  }
};
  return (
    <main>
        <DashboardLayout>
      <DashboardNavbar />
      <MedicalAbstractBackground/>
      <Box p={3}>
        <Grid container spacing={4}>
          {/* Profile Image */}
          <Grid item xs={12} md={4}>
            <Paper elevation={3} sx={{ p: 3, textAlign: "center" }}>
              <Typography variant="h6" gutterBottom>
                Profile Image
              </Typography>
              <Typography variant="body2" color="textSecondary">
                This image will be publicly visible to other users.
              </Typography>
              <Typography variant="caption" color="textSecondary">
                JPG or PNG no larger than 5 MB
              </Typography>
              <Box my={2}>
              <Avatar
  src={profileData.image ? `data:image/jpeg;base64,${profileData.image}` : ""}
  sx={{ width: 100, height: 100, mx: "auto" }}
>
  {!profileData.image && (profileData.name?.[0] || "U")}
</Avatar>
              </Box>
              <Button variant="outlined" component="label" sx={{ backgroundColor: "#1A237E", color: "ffff" }}>
                Choose File
                <input type="file" hidden
                accept="image/*"
                onChange={handleFileChange}
                />
              </Button>
            </Paper>
          </Grid>

          {/* Account Details */}
          <Grid item xs={12} md={8}>
            <Paper elevation={3} sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>
                Account Details
              </Typography>
              <Grid container spacing={2}>
               
                <Grid item xs={6}>
                  <TextField label="First Name" name="firstname" value={profileData.firstname} onChange={handleChange} fullWidth />
                </Grid>
                 <Grid item xs={6}>
                  <TextField label="Last Name" name="lastname" value={profileData.lastname} onChange={handleChange} fullWidth />
                </Grid>
               
                <Grid item xs={6}>
                  <TextField label="Date of Birth" name="dob" type="date"  
                   value={profileData.dob ? profileData.dob.slice(0, 10) : ""}
 onChange={handleChange} fullWidth InputLabelProps={{ shrink: true }} 
 />
                </Grid>
                <Grid item xs={6}>
                  <TextField label="Email" name="username" value={profileData.username} fullWidth disabled />
                </Grid>
                <Grid item xs={6}>
                  <TextField label="Phone Number" name="phoneNumber" value={profileData.phoneNumber} onChange={handleChange} fullWidth />
                </Grid>
               
                <Grid item xs={6}>
                  <TextField label="Age" name="age" value={profileData.age} onChange={handleChange} fullWidth />
                </Grid>
               <Grid item xs={6}>
  <FormControl fullWidth>
        <InputLabel>Gender</InputLabel>

    <Select

     label="Gender"
      name="gender"
      value={profileData.gender || ""}
      onChange={handleChange}
sx={{
        height: 45, // ✅ set height directly here
        "& .MuiSelect-select": {
          display: "flex",
          alignItems: "center",
          height: "100%",
          paddingY: "10px", // adjust padding if needed
        },
      }}
    >
      <MenuItem value="Male">Male</MenuItem>
      <MenuItem value="Female">Female</MenuItem>
      <MenuItem value="Other">Other</MenuItem>
    </Select>
  </FormControl>
</Grid>

<Grid item xs={6}>
  <FormControl fullWidth>
    <InputLabel>Marital Status</InputLabel>
    <Select
         label="Marital Status"

      name="martialStatus"
      value={profileData.martialStatus || ""}
      onChange={handleChange}
sx={{
        height: 45, // ✅ set height directly here
        "& .MuiSelect-select": {
          display: "flex",
          alignItems: "center",
          height: "100%",
          paddingY: "10px", // adjust padding if needed
        },
      }}
    >
      <MenuItem value="Single">Single</MenuItem>
      <MenuItem value="Married">Married</MenuItem>
      <MenuItem value="Divorced">Divorced</MenuItem>
      <MenuItem value="Widowed">Widowed</MenuItem>
    </Select>
  </FormControl>
</Grid>
              
                  <Grid item xs={6}>
                  <TextField label="Address" name="address" value={profileData.address} onChange={handleChange} fullWidth  />
                </Grid>


                <Grid item xs={6}>
  <TextField
   select
   fullWidth
   label="Country"
   name="country"
   value={profileData.country}
   onChange={(e) => handleCountryChange(e.target.value)}
    sx={{
       "& .MuiInputBase-root": {
         height: "45px",  
       },
     }}
 >
  
   {countries.map((c) => (
     <MenuItem key={c.isoCode} value={c.isoCode}>
       {c.name}
     </MenuItem>
   ))}
 </TextField>
 </Grid>



                
                <Grid item xs={6}>
                  <TextField
                   select
                   fullWidth
                   label="State"
                   name="state"
                   value={profileData.state}
                   onChange={(e) => handleStateChange(e.target.value)}
                    sx={{
                       "& .MuiInputBase-root": {
                         height: "45px",  
                       },
                     }}
                 >
                   {states.map((s) => (
                     <MenuItem key={s.isoCode} value={s.isoCode}>
                       {s.name}
                     </MenuItem>
                   ))}
                 </TextField>
                 </Grid>
                         
                                <Grid item xs={6}>
                   <TextField
                     select
                     fullWidth
                     label="City"
                     name="city"
                     value={profileData.city}
                     onChange={handleChange}
                     sx={{ "& .MuiInputBase-root": { height: "45px" } }}
                   >
                     {districts.map((d) => (
                       <MenuItem key={d.name} value={d.name}>
                         {d.name}
                       </MenuItem>
                     ))}
                   </TextField>
                 </Grid> 
                <Grid item xs={6}>
                  <TextField label="Pincode" name="pin" value={profileData.pin} onChange={handleChange} fullWidth  />
                </Grid>
                
                
                
                <Grid item xs={12} textAlign="right">
                   <Button
    variant="contained"
    sx={{
      backgroundColor: "#1A237E",
      color: "#fafcfd",
      mr: 2,
      "&:hover": {
        backgroundColor: "#1A237E",
      },
    }}
    onClick={() => navigate(-1)}
  >
    Back
  </Button>
                 <Button
  variant="contained"
  sx={{
    backgroundColor: "#1A237E",
    color: "#fafcfd",
    "&:hover": { backgroundColor: "#1A237E" },
  }}
  onClick={handleSave}
  disabled={role === "ROLE_SUPER"}
>
  SAVE CHANGES
</Button>

                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Box>
      </DashboardLayout>
    </main>
  );
}

export default ProfileIcon;
